package com.essntl.features.itinerary.ui.all_itinerary

import com.essntl.core.utils.viewmodel.State
import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.itinerary.domain.model.ItineraryFilterOptions
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.profile.domain.model.ProfileModel

data class AllItineraryState(
    val getAllItinerary: State<List<ItineraryModel>> = State(),
    val filterOptions: ItineraryFilterOptions = ItineraryFilterOptions(),
    val getAllArea: State<List<AreaModel>> = State(),
    val getAllProfile: State<List<ProfileModel>> = State(),
    val selectedItineraryId: String? = null,
)
